export const CREATOR_SITE_SECTION_DEVICE_TARGETS = ['all', 'mobile', 'desktop'] as const;

export type CreatorSiteSectionDeviceTarget = (typeof CREATOR_SITE_SECTION_DEVICE_TARGETS)[number];

export type CreatorSiteSectionVisibility = {
  device: CreatorSiteSectionDeviceTarget;
};

export const CREATOR_SITE_SECTION_VISIBILITY_DEFAULT: CreatorSiteSectionVisibility = {
  device: 'all',
};

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

export function normalizeCreatorSiteSectionVisibility(
  value: unknown,
): CreatorSiteSectionVisibility {
  if (!isPlainObject(value)) {
    return CREATOR_SITE_SECTION_VISIBILITY_DEFAULT;
  }

  const device = value.device;
  if (
    typeof device === 'string' &&
    (CREATOR_SITE_SECTION_DEVICE_TARGETS as readonly string[]).includes(device)
  ) {
    return { device: device as CreatorSiteSectionDeviceTarget };
  }

  return CREATOR_SITE_SECTION_VISIBILITY_DEFAULT;
}

export function validateCreatorSiteSectionVisibility(value: unknown) {
  if (value === undefined || value === null) {
    return { ok: true as const };
  }

  if (!isPlainObject(value)) {
    return { ok: false as const, message: 'section visibility must be an object' };
  }

  const device = value.device;
  if (
    typeof device !== 'string' ||
    !(CREATOR_SITE_SECTION_DEVICE_TARGETS as readonly string[]).includes(device)
  ) {
    return {
      ok: false as const,
      message: 'section visibility.device must be all, mobile, or desktop',
    };
  }

  return { ok: true as const };
}

export function creatorSiteSectionVisibleOnDevice(
  visibility: unknown,
  viewport: 'mobile' | 'desktop',
): boolean {
  const normalized = normalizeCreatorSiteSectionVisibility(visibility);
  if (normalized.device === 'all') {
    return true;
  }
  return normalized.device === viewport;
}
